import React, { Component } from 'react';
import {Text} from 'components/tt-forms/common';
import moment from 'moment';

export default class ThongTinChungView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      ...nextProps.details
    });
  }

  render() {
    return (
      <div className="box-items mb0">
        <div className="box-forward">
          <div className="title">
            <div className="rows">
              <div className="col-12">
                <h3 className="mb15 tt-title">1. Thông tin chung</h3>
              </div>
            </div>
          </div>
          <div className="group-box">
            <div className="items-form mb20">
              <div className="rows">
                <Text label={`Năm ${this.props.type || 'thanh tra'}:`} className='col-20' value={`Kế hoạch ${this.props.type || 'thanh tra'} năm ${this.state.namThanhTra}`}/>
                <Text label='Quyết định phê duyệt KHTT:' className='col-20' value={this.state.quyetDinhPheDuyetKTTT}/>
                <Text label='Ngày phê duyệt:' className='col-20' value={this.state.ngayRaQuyetDinh ? moment(this.state.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}/>
               </div>
            </div>
            <div className="items-form mb20">
              <div className="rows">
                <Text label='Tóm tắt kế hoạch:' className='col-100' value={this.state.ghiChu}/>
               </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/ThongTinChungView.jsx